import { createReducer, on } from '@ngrx/store';
import { defaultSenderListFilter } from '../types/sender-list-filter';
import {
  fetchSenderList,
  loadedSenderList,
  failedSenderList,
  updateSenderListFilter,
  resetSenderList,
} from './sender-list.actions';
import {
  initialSenderListState,
  SenderListState,
  initialDataSource,
} from './sender-list.state';

export const senderListReducer = createReducer(
  initialSenderListState,
  on(fetchSenderList, (state): SenderListState => ({ ...state })),
  on(loadedSenderList, (state, action): SenderListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedSenderList, (state): SenderListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(updateSenderListFilter, (state, { filter }): SenderListState => {
    return {
      ...state,
      filter: { ...state.filter, ...(filter ?? defaultSenderListFilter) },
      dataSource: { ...state.dataSource },
    };
  }),
  on(resetSenderList, (state): SenderListState => {
    return {
      ...state,
      filter: { ...defaultSenderListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
